// lib
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { List, Map } from 'immutable'
import { Transition } from 'react-transition-group'
import { secondsToMMSS } from '@aytm/lib/common/func'

// components
import VideoPopup from '@aytm/lib/rfd-ui/components/basic/video-popup'

// styles
import '@aytm/lib/rfd-ui/styles/advanced/tutorial-video-list.scss'

// <Component>
TutorialVideoList.propTypes = {
  tooltip: PropTypes.string,
  title: PropTypes.string,
  video: PropTypes.instanceOf(Map).isRequired,
  videoPoints: PropTypes.instanceOf(List).isRequired,
  videoNote: PropTypes.string,
  className: PropTypes.string,
  videoThumbnail: PropTypes.string,
  targetClassName: PropTypes.string,
  hiddenText: PropTypes.bool
}
export default function TutorialVideoList(props) {
  const { video, tooltip, className, targetClassName, hiddenText } = props

  const [opened, setOpened] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [startTime, setStartTime] = useState(0)

  const openedRef = useRef(opened)
  openedRef.current = opened

  const setPopup = ({ showPopup, startTime }) => {
    setShowPopup(showPopup)
    setStartTime(startTime)
  }

  const onButtonClick = () => {
    setOpened(!openedRef.current)
    setStartTime(0)
  }

  const onCloseButtonClick = () => {
    setOpened(false)
    setStartTime(0)
  }

  return (
    <div
      title={tooltip || 'Tutorial video list'}
      className={classNames('rfd-ui-tutorial-video-list', {
        'rfd-ui-tutorial-video-list-opened': opened,
        [className]: className
      })}
    >
      <div className="rfd-ui-tutorial-video-list-button" onClick={onButtonClick}>
        {!hiddenText ? <span className="rfd-ui-tutorial-video-list-button-text">Tutorial video</span> : null}
        <span className="rfd-ui-tutorial-video-list-button-icon">
          <i className={classNames('icon-aytmfd-videotut', { [targetClassName]: targetClassName })} />
        </span>
      </div>
      <Transition in={opened} timeout={1000}>
        {status => (
          <div
            className={classNames('rfd-ui-tutorial-video-list-container', {
              'rfd-ui-tutorial-video-list-container-opened': 'entered' == status,
              'rfd-ui-tutorial-video-list-container-opening': 'entering' == status,
              'rfd-ui-tutorial-video-list-container-closed': 'exited' == status,
              'rfd-ui-tutorial-video-list-container-closing': 'exiting' == status
            })}
          >
            {renderVideoList({ ...props, setPopup, onCloseButtonClick })}
          </div>
        )}
      </Transition>
      <VideoPopup
        videoStartTime={startTime}
        onClose={() => setPopup({ showPopup: false, startTime: 0 })}
        videos={List().set(0, video)}
        show={showPopup}
      />
    </div>
  )
}

function renderVideoList({ title, video, videoPoints, videoNote, videoThumbnail, setPopup, onCloseButtonClick }) {
  const videoLength = video.get('length')
  return (
    <>
      <span className="rfd-ui-tutorial-video-list-close-button" onClick={onCloseButtonClick}>
        <i className="icon-aytmfd-delete" />
      </span>
      <div
        className="rfd-ui-tutorial-video-list-video-thumbnail"
        onClick={() => setPopup({ showPopup: true, startTime: 0 })}
      >
        <img src={videoThumbnail} alt="video thumbnail" />
        <i className="icon-aytmfd-play" />
      </div>
      <div className="rfd-ui-tutorial-video-list-video-points">
        <div className="rfd-ui-tutorial-video-list-video-points-title">
          {title || 'Tutorial video'} ({Number.isInteger(videoLength) ? secondsToMMSS(videoLength) : videoLength})
        </div>
        <div className="rfd-ui-tutorial-video-list-video-points-note">{videoNote}</div>
        <ul>
          {videoPoints.map((point, index) => (
            <li
              key={index}
              onClick={() => setPopup({ showPopup: true, startTime: point.get('time') })}
              className="rfd-ui-tutorial-video-list-video-points-link"
            >
              {secondsToMMSS(point.get('time'))} – {point.get('text')}
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
